<template>

  <div class="card shadow"
       :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div id="errorNotification" class="col-md-12">
          <base-alert v-if="errorMessage != null" type="danger">
              <span class="alert-inner--text"> {{errorMessage}}</span>
              <button type="button" class="close" aria-label="Close" @click="removeMessage('error')">
                 <span aria-hidden="true">&times;</span>
              </button>
          </base-alert>
          <base-alert v-if="successMessage != null" type="success">
              <span class="alert-inner--text"> {{successMessage}}</span>
              <button type="button" class="close" aria-label="Close" @click="removeMessage('success')">
                 <span aria-hidden="true">&times;</span>
              </button>
          </base-alert>
        </div>
        <div class="col-md-5">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
            {{selectedDocumentName}}
          </h3>
        </div>
        <div class="col-md-7 text-right">
        <base-dropdown class="nav-link pr-0 float-right" position="right">
            <div class="media align-items-center" slot="title">
              <i class="fa fa-ellipsis-v float-right ml-2 btn-sm"></i>
            </div>
            <template>
              <div class="dropdown-header noti-title">
                <h6 class="text-overflow m-0">ACTIONS</h6>
              </div>
              <div v-if="accessRights.includes('T')" class="dropdown-item" @click.prevent="showActionDrawer('print_list')">
                  <i class="fa fa-print"></i>
                  <span>Print</span>
              </div>
              <div class="dropdown-item" @click.prevent="showActionDrawer('configure')">
                  <i class="ni ni-settings-gear-65"></i>
                  <span>Configure</span>
              </div>
              <div class="dropdown-item" @click.prevent="showActionDrawer('configurationhist')">
                <i class="fa fa-history"></i>
                <span>Configuration History</span>
            </div>
            </template>
          </base-dropdown>
          <div v-if="checkedItems.length == 0 && accessRights.includes('A') && currentDocumentTypeCode!='RECTRX'">
            <div v-if='currentDocumentTypeCode=="RELDDE" || currentDocumentTypeCode=="OTHSIN" || currentDocumentTypeCode=="OTHSBI" || currentDocumentTypeCode=="OTHTRA" || currentDocumentTypeCode=="OTHCNS" || currentDocumentTypeCode=="RECCSR" || currentDocumentTypeCode=="ORORSO"'>
               <base-button class="float-right ml-1" type="primary" size="sm" @click.prevent="showDocumentDrawer(selectedDocumentName)">+ Add New {{selectedDocumentName}}</base-button>
            </div>
            <div v-else>
              <router-link  :to="{ name: 'document_form', params: { id: -1 } }" v-if='!isRestrictedWithoutOriginDoc'>
                <base-button v-if='currentDocumentTypeCode!="OTHPCK"' class="float-right ml-1" type="primary" size="sm">+ Add New {{selectedDocumentName}}</base-button>
              </router-link>
            </div>
          </div>
          <div v-if="checkedItems.length > 0 && accessRights.includes('A') && currentDocumentTypeCode=='RELDDE'">
            <div>
               <base-button class="float-right ml-1" type="primary" size="sm" @click.prevent="GenerateBatchPickingList()">Generate Batch Picking List</base-button>
            </div>

          </div>
        </div>
      </div>
    </div>

    <a-drawer title="" :width="480" placement="right" @close="onClose" :visible="drawerVisible">
       <div v-if="profileAction == 'customize_list'">
         <h6 class="heading-small text-muted mb-4">Customize Fields</h6>
          <ul v-if="availableFields.length > 0" class="list-group list-group-flush" style="width: 100%">
              <li class="list-group-item" style="font-size: 14px; height: 55px; background-color: #f7f7f7">
                  <div class="row">
                      <div class="col-md-6">
                          AVAILABLE FIELDS
                      </div>
                      <div class="col-md-6">
                         <a-checkbox @change="onCheckAllField" :checked="fields.length == (availableFields.length + 4)" class="float-right"/>
                      </div>
                   </div>
              </li>
              <li class="list-group-item" style="font-size: 14px" v-for="field in availableFields">
                   <div class="row">
                       <div class="col-md-6">
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{field}}
                      </div>
                      <div class="col-md-6">
                          <a-checkbox @change="onCheckField(field)" :checked="fields.includes(field)" class="float-right"/>
                      </div>
                   </div>
              </li>
          </ul>
       </div>

       <div v-if="profileAction == 'export_list'">
         <h6 class="heading-small text-muted mb-4">Export Options</h6>

        <base-alert v-if="errors.length" type="danger">
            <b>You have the following error(s):</b>
              <ul>
                <li v-for="error in errors">{{ error }}</li>
            </ul>
        </base-alert>

          <div>
            <a-radio-group v-model="exportSelection">
              <a-radio :style="radioStyle" :value="0">Export All</a-radio>
              <a-radio :style="radioStyle" :value="1">Export Current Page</a-radio>
              <a-radio :style="radioStyle" :value="2">Export Selected</a-radio>
              <a-radio :style="radioStyle" :value="3">Export Filtered</a-radio>
            </a-radio-group>
          </div>
          <div style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
            <button type="button" class="btn btn-primary float-right" @click.prevent="download">Export</button>
          </div>
        </div>
        <div v-if="profileAction == 'print_list'">
          <h6 class="heading-small text-muted mb-4">Print Options</h6>
        </div>
    </a-drawer>

    <a-drawer title="" :width="800" placement="right" @close="onClose" :visible="configVisible">
        <div v-if="profileAction == 'configure'">
          <document-configuration @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage" :key="componentKey"></document-configuration>
        </div>
    </a-drawer>

    <a-drawer title="" :width="1200" placement="right" @close="onClose" :visible="configHistoryVisible">
        <div v-if="profileAction == 'configurationhist'">
          <document-configuration-history @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage" :key="componentKey"></document-configuration-history>
        </div>
    </a-drawer>

    <a-drawer title="" wrapClassName='document-form-drawer' :width="windowWidth" placement="right" @close="onClose" :visible="visible">
        <div>
          <!-- <dynamic-form :parameters="JSON.stringify(documentType)" :convertedJson="convertedJson" :key="componentKey"></dynamic-form> <hr> -->
          <document-form @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage" :key="componentKey" :documentNumber="documentNumber"></document-form>
        </div>
    </a-drawer>
    <div class="table-responsive">
      <a-spin :spinning="loading">
        <vuetable ref="vuetable"
          :api-url="apiURL"
          :http-options="httpOptions"
          :fields="fields"
          :sort-order="sortOrder"
          :show-sort-icons="true"
          :per-page="10"
          :css="css.table"
          no-data-template="Empty"
          pagination-path=""
          data-path="data"
          @vuetable:checkbox-toggled-all="log"
          @vuetable:checkbox-toggled="log"
          @vuetable:load-error="onLoadError"
          @vuetable:pagination-data="onPaginationData"
          @vuetable:loaded="onLoaded">   
            <template slot="actions" slot-scope="props">
                <center>
                  <a-dropdown>
                    <a class="ant-dropdown-link" @click="e => e.preventDefault()">
                      <i class="fa fa-ellipsis-v"> </i>
                    </a>
                    <a-menu slot="overlay">
                      <a-menu-item key="1">
                        <router-link  v-if="accessRights.includes('W') || accessRights.includes('V')" :to="{ name: 'document_form', params: { id: props.rowData.id} }" >
                          <a class="btn btn-success btn-sm text-white">Open</a>
                        </router-link>
                      </a-menu-item>
                      <a-menu-item key="2">
                        <div v-if="props.rowData.order_source!='lazada' && props.rowData.order_source!='shopee' && props.rowData.order_source!='shopify' && props.rowData.has_child_doc == false">
                          <a-popconfirm v-if="currentDocumentTypeCode == 'OTHASM' || currentDocumentTypeCode == 'OTHDSM' || currentDocumentTypeCode=='RELDDE' || currentDocumentTypeCode == 'OTHPWS'" title="You are about to void this record?" @confirm="deleteRow(props.rowData.id)" okText="Void" cancelText="Cancel">
                            <a-button v-if="props.rowData.status != 'Voided' && props.rowData.status != 'Posted'" class="btn btn-danger btn-sm text-white">Void</a-button>
                          </a-popconfirm>
                          <a-popconfirm v-else-if="currentDocumentTypeCode == 'ORORSO'" title="You are about to void this record?" @confirm="deleteRow(props.rowData.id)" okText="Void" cancelText="Cancel">
                            <a-button v-if="props.rowData.status != 'Voided' && props.rowData.status != 'Posted' && props.rowData.status != 'Confirmed'" class="btn btn-danger btn-sm text-white">Void</a-button>
                          </a-popconfirm>
                          <a-popconfirm v-else title="You are about to void this record?" @confirm="deleteRow(props.rowData.id)" okText="Void" cancelText="Cancel">
                            <a-button v-if="props.rowData.status != 'Voided'" class="btn btn-danger btn-sm text-white">Void</a-button>
                          </a-popconfirm>
                        </div>
                        <div v-else-if="(props.rowData.order_source=='lazada' || props.rowData.order_source=='shopee' || props.rowData.order_source=='shopify') && props.rowData.has_child_doc == false">
                          <div v-if="currentDocumentTypeCode=='RELDDE'">
                            <a-popconfirm title="You are about to void this record?" @confirm="deleteEcomOrder(props.rowData)" okText="Void" cancelText="Cancel">
                              <a-button v-if="props.rowData.status != 'Voided' && props.rowData.status != 'Posted'" class="btn btn-danger btn-sm text-white">Void</a-button>
                            </a-popconfirm>
                          </div>
                          <div v-if="currentDocumentTypeCode!='RELDDE'">
                            <a-popconfirm v-if="currentDocumentTypeCode == 'OTHASM' || currentDocumentTypeCode == 'OTHDSM' || currentDocumentTypeCode == 'OTHPWS'" title="You are about to void this record?" @confirm="deleteRow(props.rowData.id)" okText="Void" cancelText="Cancel">
                              <a-button v-if="props.rowData.status != 'Voided' && props.rowData.status != 'Posted'" class="btn btn-danger btn-sm text-white">Void</a-button>
                            </a-popconfirm>
                            <a-popconfirm v-else-if="currentDocumentTypeCode == 'ORORSO'" title="You are about to void this record?" @confirm="deleteRow(props.rowData.id)" okText="Void" cancelText="Cancel">
                              <a-button v-if="props.rowData.status != 'Voided' && props.rowData.status != 'Posted' && props.rowData.status != 'Confirmed'" class="btn btn-danger btn-sm text-white">Void</a-button>
                            </a-popconfirm>
                            <a-popconfirm v-else title="You are about to void this record?" @confirm="deleteRow(props.rowData.id)" okText="Void" cancelText="Cancel">
                              <a-button v-if="props.rowData.status != 'Voided'" class="btn btn-danger btn-sm text-white">Void</a-button>
                            </a-popconfirm>
                          </div>
                        </div>
                      </a-menu-item>
                    </a-menu>
                  </a-dropdown>
                </center>
            </template>
            <template slot="target_date" slot-scope="props">
              <div v-if="props.rowData.order_source=='lazada' || props.rowData.order_source=='shopee' || props.rowData.order_source=='shopify'">
                <span v-if="moment(props.rowData.target_date).diff(new Date(), 'hours') > 24" class="text-success font-weight-bold">{{props.rowData.target_date}} </span>
                <span v-else-if="moment(props.rowData.target_date).diff(new Date(), 'hours') < 24 && moment(props.rowData.target_date).diff(new Date(), 'hours') > 0" class="text-warning font-weight-bold">{{props.rowData.target_date}} </span>
                <span v-else-if="moment(props.rowData.target_date).diff(new Date(), 'hours') < 0" class="text-danger font-weight-bold">{{props.rowData.target_date}} </span>
                <label v-if="moment(props.rowData.target_date).diff(new Date(), 'hours') > 24" class="bg-info p-1 text-white rounded">
                  <small class="font-weight-bold">{{moment(props.rowData.target_date).diff(new Date(), "hours")}} hrs left</small>
                </label>
                <label v-if="moment(props.rowData.target_date).diff(new Date(), 'hours') < 24 && moment(props.rowData.target_date).diff(new Date(), 'hours') > 0" class="bg-warning p-1 text-white rounded">
                  <small class="font-weight-bold">{{moment(props.rowData.target_date).diff(new Date(), 'hours')}}hr<span v-if="moment(props.rowData.target_date).diff(new Date(), 'hours') > 1">s</span> left</small>
                </label>
                <label v-if="moment(props.rowData.target_date).diff(new Date(), 'hours') < 0" class="bg-danger p-1 text-white rounded">
                  <small class="font-weight-bold">SLA Breached</small>
                </label>
              </div>
            </template>
        </vuetable>
      </a-spin>
    </div>

    <div class="card-footer d-flex justify-content-end"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="pagination ui basic segment grid">
        <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage" :css="css.pagination"></vuetable-pagination>
      </div>
    </div>

    <!-- Drawer for Delivery Document -->
    <a-drawer title="Please select a sales order document" wrapClassName='document-form-drawer' :width="600" placement="right" @close="onClose" :visible="deliveryDocumentDrawerVisible">
      <VueTabulator ref="tabulator" :options="deliveryDocumentOptions"/>
      <div v-if="allowCreationOfDDWithoutSO" style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
          <button type="button" class="btn btn-primary float-right" @click.prevent="DeliveryDocumentNoOrigin">Create without origin document</button>
      </div>
    </a-drawer>

    <!-- Drawer for Re-routed SO -->
    <a-drawer title="Please select a sales order document" wrapClassName='document-form-drawer' :width="600" placement="right" @close="onClose" :visible="reRoutedSODrawerVisible">
      <VueTabulator ref="tabulator" :options="ReRoutedSOOptions"/>
    </a-drawer>

    <!-- Drawer for Customer Return -->
    <a-drawer title="Please select a delivery document" wrapClassName='document-form-drawer' :width="600" style="display: flex;" placement="right" @close="onClose" :visible="customerReturnDrawerVisible">
      <VueTabulator ref="tabulator" v-model="customerReturnData" :options="customerReturnOptions"/>
      <router-link  :to="{ name: 'document_form', params: { id: -2 } }">
        <base-button class="float-right ml-1" style="align-self: flex-end;" type="primary" size="sm">Create Open Customer Return Document</base-button>
      </router-link>
    </a-drawer>

    <!-- Drawer for Sales Invoice -->
    <a-drawer title="Please select a delivery document" wrapClassName='document-form-drawer' :width="600" placement="right" @close="onClose" :visible="salesInvoiceDrawerVisible">
      <VueTabulator ref="tabulator" v-model="salesInvoiceData" :options="salesInvoiceOptions"/>
    </a-drawer>

    <!-- Drawer for Suppliers Bill -->
    <a-drawer title="Please select a receiving report document" wrapClassName='document-form-drawer' :width="600" placement="right" @close="onClose" :visible="suppliersBillDrawerVisible">
      <VueTabulator ref="tabulator" v-model="suppliersBillData" :options="suppliersBillOptions"/>
    </a-drawer>

    <!-- Drawer for Transfer Allocation-- -->
    <a-drawer title="Please select an origin document" wrapClassName='document-form-drawer' :width="600" placement="right" @close="onClose" :visible="transferAllocationDrawerVisible">
    <base-alert v-if="TAErrorMessage != null" type="danger">
          <span class="alert-inner--text"> {{TAErrorMessage}}</span>
          <button type="button" class="close" aria-label="Close" @click="removeMessage('error')">
              <span aria-hidden="true">&times;</span>
          </button>
      </base-alert>
      <VueTabulator ref="tabulator" v-model="transferAllocationData" :options="transferAllocationOptions"/>

      <div style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
          <button type="button" class="btn btn-primary float-right" @click.prevent="transferAllocationNoOrigin">Create without origin document</button>
      </div>

    </a-drawer>

    <!-- Drawer for Count Set-- -->
    <a-drawer title="Please select a physical count document" wrapClassName='document-form-drawer' :width="600" placement="right" @close="onClose" :visible="countSetDrawerVisible">
      <base-alert v-if="pcountErrorMessage != null" type="danger">
          <span class="alert-inner--text"> {{pcountErrorMessage}}</span>
          <button type="button" class="close" aria-label="Close" @click="removeMessage('error')">
              <span aria-hidden="true">&times;</span>
          </button>
      </base-alert>
      <VueTabulator ref="tabulator" v-model="countSetData" :options="countSetOptions"/>
      <div style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
          <button type="button" class="btn btn-primary float-right" @click.prevent="countSetClickNext">Next</button>
      </div>
    </a-drawer>

    <!-- Drawer for ecom-- -->
    <a-drawer title="" :width="600" placement="right" @close="onClose" :visible="documentEcomDrawerVisible" v-if="documentEcomDrawerVisible">
      <div>
          <document-ecom-form @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage" @deleteRow="deleteRow" :ecomAction="ecomAction" :documentDetails="documentDetails"> </document-ecom-form>
      </div>
    </a-drawer>
  </div>
</template>

<script>
  import axios from "axios";
  import { mapState, mapActions } from 'vuex'
  import moment from 'moment';

  import Vuetable from "vuetable-2/src/components/Vuetable";
  import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
  import secureStorage from '../../controllers/secureStorage';
  import HTTPRequest from '../../controllers/httpRequest.js'
  import DocumentForm from '../Documents/DocumentForm.vue'
  import DocumentEcomForm from '../Documents/DocumentEcomForm.vue'

  import DocumentConfiguration from '../Documents/DocumentConfiguration.vue'
  import DocumentConfigurationHistory from '../Documents/DocumentConfigurationHistory.vue'

  var component_x;

  var ORIOROTRQ = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'reference', title: 'Reference'}, { name: 'origin_document_id.label', title: 'Origin Doc#'},  { name: 'document_date', title: 'Document Date'}, {name: "source_site_id.label", title: 'From'}, {name: "target_site_id.label", title: 'To'}, {name: "status", title: 'Status'} , {name: "order_status", title: 'Order Status'}, {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}];
  var RECTRX = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'reference', title: 'Reference'}, { name: 'origin_document_id.label', title: 'Origin Doc#'},  { name: 'document_date', title: 'Document Date'}, {name: "source_site_id.label", title: 'From'}, {name: "target_site_id.label", title: 'To'}, {name: "status", title: 'Status'}, {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}];
  var RELTRX = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'reference', title: 'Reference'}, { name: 'origin_document_id.label', title: 'Origin Doc#'},  { name: 'document_date', title: 'Document Date'}, {name: "source_site_id.label", title: 'From'}, {name: "target_site_id.label", title: 'To'}, {name: "status", title: 'Status'}, {name: "order_status", title: 'Order Status'}, {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}, {name: "is_exported", title: 'Export Status'}];
  var RECSLI = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'reference', title: 'Reference'}, { name: 'origin_document_id.label', title: 'Origin Doc#'},  { name: 'document_date', title: 'Document Date'}, {name: "site_id.label", title: 'Site'}, {name: "origin_sublocation_id.label", title: 'From'}, {name: "target_sublocation_id.label", title: 'To'}, {name: "status", title: 'Status'}, {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}];
  var RELSLO = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'reference', title: 'Reference'}, { name: 'origin_document_id.label', title: 'Origin Doc#'},  { name: 'document_date', title: 'Document Date'}, {name: "site_id.label", title: 'Site'}, {name: "origin_sublocation_id.label", title: 'From'}, {name: "target_sublocation_id.label", title: 'To'}, {name: "status", title: 'Status'}, {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}];
  var ORIPOX = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'reference', title: 'Reference'}, { name: 'origin_document_id.label', title: 'Origin#'},  { name: 'document_date', title: 'Document Date'}, {name: "supplier_id.label", title: 'Supplier'}, {name: "site_id.label", title: 'Deliver To'}, {name: "status", title: 'Status'}, {name: "order_status", title: 'Order Status'}, {name: "amount_net", title: 'Amount'},{name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}, {name: "is_exported", title: 'Export Status'}]; //FIX ORIGIN#
  var OTHPUR = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'reference', title: 'Reference'}, { name: 'origin_document_id.label', title: 'Origin#'},  { name: 'document_date', title: 'Document Date'}, {name: "supplier_id.label", title: 'Supplier'}, {name: "site_id.label", title: 'Deliver To'}, {name: "status", title: 'Status'}, {name: "order_status", title: 'Order Status'}, {name: "amount_net", title: 'Amount'},{name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}, {name: "is_exported", title: 'Export Status'}]; //FIX ORIGIN#
  var RECDEL = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'origin_document_id.label', title: 'PO#'},  { name: 'document_date', title: 'Document Date'}, {name: "supplier_id.label", title: 'Supplier'}, {name: "site_id.label", title: 'Deliver To'}, {name: "status", title: 'Status'},{name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}];  //FIX PO#
  var RELRSR = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'reference', title: 'Ref#'},  { name: 'document_date', title: 'Document Date'}, {name: "supplier_id.label", title: 'Supplier'},{name: "status", title: 'Status'},{name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}]; //Fix Ref#
  var RECRELADJ = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'origin_document_id.label', title: 'Origin Doc'}, { name: 'reference', title: 'Reference'},  { name: 'document_date', title: 'Document Date'}, {name: "purpose_id.label", title: 'Purpose'},{name: "party_receiver_name", title: 'Party'}, {name: "status", title: 'Status'},{name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}]; //Fix Ref#
  var OTHPCN = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'reference', title: 'Reference'},  { name: 'document_date', title: 'Document Date'}, {name: "party_receiver_name", title: 'Party'}, {name: "total_quantity", title: 'Total Quantity'}, {name: "amount_net", title: 'Total Amount'}, {name: "status", title: 'Status'}, {name: "order_status", title: 'Order Status'}, {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}]; //Fix Ref#
  var OTHASMDSM = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'reference', title: 'Reference'},  { name: 'document_date', title: 'Document Date'}, {name: "party_receiver_name", title: 'Party'}, {name: "status", title: 'Status'}, {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}]; //Fix Ref#
  var ORISOX = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'reference', title: 'Reference'}, { name: 'document_date', title: 'Document Date'}, { name: 'target_date', title: 'Target Date'}, {name: "customer_id.label", title: 'Customer'}, {name: "site_id.label", title: 'Site'}, {name: "target_sublocation_id.label", title: 'Sublocation'}, {name: "status", title: 'Status'}, {name: "order_status", title: 'Order Status'}, {name: "payment_status", title: 'Payment Status'}, {name: "amount_net", title: 'Amount'},{name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}];
  var RELDDE = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'origin_document_id.label', title: 'SO Reference Document'},  { name: 'document_date', title: 'Document Date'}, {name: "customer_id.label", title: 'Customer'}, {name: "site_id.label", title: 'Site'}, {name: "target_sublocation_id.label", title: 'Deliver To'}, {name: "status", title: 'Status'}, {name: "order_status", title: 'Order Status'}, {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}];
  var ORORSO = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'origin_document_id.label', title: 'SO Reference Document'},  { name: 'document_date', title: 'Document Date'}, {name: "site_id.label", title: 'Site'}, {name: "target_site_id.label", title: 'Target Site'}, {name: "target_sublocation_id.label", title: 'Deliver To'}, {name: "status", title: 'Status'}, {name: "order_status", title: 'Order Status'}, {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}];
  var OTHSIN = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'so_ref_no.label', title: 'SO Reference Document'}, { name: 'origin_document_id.label', title: 'DD Reference Document'}, { name: 'document_date', title: 'Document Date'}, {name: "customer_id.label", title: 'Customer'}, {name: "site_id.label", title: 'Site'}, {name: "target_sublocation_id.label", title: 'Sublocation'}, {name: "status", title: 'Status'}, {name: "order_status", title: 'Order Status'}, {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}];
  var ORISOXSRC = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'reference', title: 'Reference'}, { name: 'document_date', title: 'Document Date'}, { name: 'target_date', title: 'Target Date'}, {name: "customer_id.label", title: 'Customer'}, {name: "site_id.label", title: 'Site'}, {name: "order_source", title: 'Order Source'}, {name: "status", title: 'Status'}, {name: "order_status", title: 'Order Status'}, {name: "payment_status", title: 'Payment Status'}, {name: "amount_net", title: 'Amount'},{name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}];
  var RELDDESRC = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'origin_document_id.label', title: 'SO Reference Document'},  { name: 'document_date', title: 'Document Date'}, {name: "customer_id.label", title: 'Customer'}, {name: "site_id.label", title: 'Site'}, {name: "status", title: 'Status'}, {name: "order_status", title: 'Order Status'}, {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}];
  var OTHSINSRC = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'so_ref_no.label', title: 'SO Reference Document'}, { name: 'origin_document_id.label', title: 'DD Reference Document'}, { name: 'document_date', title: 'Document Date'}, {name: "customer_id.label", title: 'Customer'}, {name: "site_id.label", title: 'Site'}, {name: "order_source", title: 'Order Source'}, {name: "status", title: 'Status'}, {name: "order_status", title: 'Order Status'}, {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}];
  var ORORSOSRC = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'origin_document_id.label', title: 'SO Reference Document'},  { name: 'document_date', title: 'Document Date'}, {name: "site_id.label", title: 'Site'}, {name: "target_site_id.label", title: 'Target Site'}, {name: "status", title: 'Status'}, {name: "order_status", title: 'Order Status'}, {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}];
  var OTHSBI = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'origin_document_id.label', title: 'RR#'}, { name: 'document_date', title: 'Document Date'}, {name: "supplier_id.label", title: 'Supplier'}, {name: "site_id.label", title: 'Deliver To'}, {name: "status", title: 'Status'}, {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}];
  var OTHPWS = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'reference', title: 'Reference'}, {name: "party_receiver_name", title: 'Party'}, { name: 'document_date', title: 'Document Date'}, {name: "site_id.label", title: 'Target Site'}, {name: "target_date", title: 'Effectivity Date'}, {name: "status", title: 'Status'}, {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}];
  var ORIASN = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'reference', title: 'Reference'}, { name: 'origin_document_id.label', title: 'Origin#'},  { name: 'document_date', title: 'Document Date'}, {name: "supplier_id.label", title: 'Supplier'}, {name: "site_id.label", title: 'Deliver To'}, {name: "status", title: 'Status'}, {name: "order_status", title: 'Order Status'}, {name: "amount_net", title: 'Amount'},{name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}, {name: "is_exported", title: 'Export Status'}]; //FIX ORIGIN#
  var OTHTRA = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'reference', title: 'Reference'}, { name: 'origin_document_id.label', title: 'Origin Doc#'},  { name: 'document_date', title: 'Document Date'}, {name: "source_site_id.label", title: 'From'}, {name: "target_site_id.label", title: 'To'}, {name: "status", title: 'Status'}, {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}];
  var OTHPCK = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'reference', title: 'Reference'}, { name: 'origin_document_id.label', title: 'Origin Doc#'},  { name: 'document_date', title: 'Document Date'}, {name: "source_site_id.label", title: 'From'}, {name: "target_site_id.label", title: 'To'}, {name: "status", title: 'Status'}, {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}];
  var OTHCNS = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'reference', title: 'Reference'},  { name: 'document_date', title: 'Document Date'}, {name: "party_receiver_name", title: 'Party'}, {name: "total_quantity", title: 'Total Quantity'}, {name: "amount_net", title: 'Total Amount'}, {name: "status", title: 'Status'}, {name: "order_status", title: 'Order Status'}, {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}]; //Fix Ref#
  var RECCSR = ['__checkbox', '__slot:actions', { name: 'document_no', title: 'No.', sortField: 'document_no'}, { name: 'origin_document_id.label', title: 'Delivery Document Reference'},  { name: 'document_date', title: 'Document Date'}, {name: "customer_id.label", title: 'Customer'}, {name: "site_id.label", title: 'Site'}, {name: "target_sublocation_id.label", title: 'Return To'}, {name: "status", title: 'Status'}, {name: "order_status", title: 'Order Status'}, {name: "created_by", title: 'Created By'}, {name: "posted_by", title: 'Posted By'}, {name: "posted_at", title: 'Posted At'}];


  export default {
    name: 'profiles-table',
    props: {
      type: {
        type: String
      },
      title: String,
      selectedDocumentName: String
    },
    components: {
        Vuetable,
        VuetablePagination,
        DocumentForm,
        DocumentEcomForm,
        DocumentConfiguration,
        DocumentConfigurationHistory
    },
    computed: {
        ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'profileId', 'parameters', 'serverType']),
    },
    data() {
      return {
        documentTypex: null,
        isSourceMode: null,
        deliveryDocumentOptions: {
          ajaxURL:'',
          ajaxConfig:{
            method:"GET", 
            headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web" },
          },
          pagination:"remote",
          paginationDataSent:{
            "page":"page",
            "size":"per_page"
          },
          paginationSize:10,
          layout:"fitDataStretch",
          rowClick: this.salesOrderRowClick,
          showData:[],
          columns: [
            {
            title: 'Document Date',
            field: 'document_date',
            sorter: 'string',
            headerFilter:"input"
            },
            {
            title: 'SO#',
            field: 'code_and_document_no',
            sorter: 'number',
            headerFilter:"input"
            },
            {
            title: 'Order Source',
            field: 'order_source',
            sorter: 'string',
            headerFilter:"input"
            },
            {
            title: 'Customer',
            field: 'customer_id.label',
            sorter: 'string',
            headerFilter:"input"
            },
            {
            title: 'Site',
            field: 'site_id.label',
            sorter: 'string',
            headerFilter:"input"
            },
            {
            title: 'Sublocation',
            field: 'target_sublocation_id.label',
            sorter: 'string',
            headerFilter:"input"
            },
          ],
        },
        deliveryDocumentModal: false,
        deliveryDocumentData: [],
        customerReturnData: [],
        customerReturnModal: false,
        customerReturnOptions: {
          pagination:"local",
          paginationSize:10,
          layout:"fitDataStretch",
          rowClick: this.salesOrderRowClick,
          columns: [
              {
              title: 'Document Date',
              field: 'document_date',
              sorter: 'string',
              headerFilter:"input"
              },
              {
              title: 'DD#',
              field: 'code_and_document_no',
              sorter: 'number',
              headerFilter:"input"
              },
              {
              title: 'Order Source',
              field: 'order_source',
              sorter: 'string',
              headerFilter:"input"
              },
              {
              title: 'Customer',
              field: 'customer_id.label',
              sorter: 'string',
              headerFilter:"input"
              },
              {
              title: 'Site',
              field: 'site_id.label',
              sorter: 'string',
              headerFilter:"input"
              },
              {
              title: 'Sublocation',
              field: 'target_sublocation_id.label',
              sorter: 'string',
              headerFilter:"input"
              },

          ],
        },
        salesInvoiceOptions: {
          pagination:"local",
          paginationSize:10,
          layout:"fitDataStretch",
          rowClick: this.deliveryDocumentRowClick,
          columns: [
              {
              title: 'Document Date',
              field: 'document_date',
              sorter: 'string',
              headerFilter:"input"
              },
              {
              title: 'Customer',
              field: 'customer_id.label',
              sorter: 'string',
              headerFilter:"input"
              },
              {
              title: 'Sales Order',
              field: 'origin_document_id.label',
              sorter: 'string',
              headerFilter:"input"
              },
              {
              title: 'Delivery Document',
              field: 'id',
              sorter: 'number',
              headerFilter:"input"
              }

          ],
        },
        suppliersBillOptions: {
          pagination:"local",
          paginationSize:10,
          layout:"fitDataStretch",
          rowClick: this.receivingReportRowClick,
          columns: [
              {
              title: 'Document Date',
              field: 'document_date',
              sorter: 'string',
              headerFilter:"input"
              },
              {
              title: 'Supplier',
              field: 'supplier_id.label',
              sorter: 'string',
              headerFilter:"input"
              },
              {
              title: 'Reciving Report #',
              field: 'id',
              sorter: 'number',
              headerFilter:"input"
              }

          ],
        },
        transferAllocationOptions: {
          pagination:"local",
          paginationSize:10,
          layout:"fitDataStretch",
          rowClick: this.transferAllocationRowClick,
          columns: [
              {
              title: 'Document Type',
              field: 'document_name',
              sorter: 'string',
              headerFilter:"input"
              },
              
              {
              title: 'Document #',
              field: 'code_and_document_no',
              sorter: 'number',
              headerFilter:"input"
              },
              {
              title: 'Document Date',
              field: 'document_date',
              sorter: 'string',
              headerFilter:"input"
              },
          ],
        },
        countSetOptions: {
          pagination:"local",
          paginationSize:10,
          layout:"fitDataStretch",
          columns: [
              {
                title: 'Action',
                align:'center',
                formatter: this.addCountSetCheckBox,
                cellClick: this.selectPCountAction
              },
              {
              title: 'PCount Number',
              field: 'code_and_document_no',
              sorter: 'string',
              headerFilter:"input"
              },
              {
              title: 'Document Type',
              field: 'document_name',
              sorter: 'string',
              headerFilter:"input"
              },
              {
              title: 'Document Date',
              field: 'document_date',
              sorter: 'string',
              headerFilter:"input"
              },

          ],
        },
        reRoutedSOModal: false,
        reRoutedSOData: [],
        ReRoutedSOOptions: {
          ajaxURL:'',
          ajaxConfig:{
            method:"GET", 
            headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web" },
          },
          pagination:"remote",
          paginationDataSent:{
            "page":"page",
            "size":"per_page"
          },
          paginationSize:10,
          layout:"fitDataStretch",
          rowClick: this.salesOrderRowClick,
          showData:[],
          columns: [
            {
            title: 'Document Date',
            field: 'document_date',
            sorter: 'string',
            headerFilter:"input"
            },
            {
            title: 'SO#',
            field: 'code_and_document_no',
            sorter: 'number',
            headerFilter:"input"
            },
            {
            title: 'Order Source',
            field: 'order_source',
            sorter: 'string',
            headerFilter:"input"
            },
            {
            title: 'Customer',
            field: 'customer_id.label',
            sorter: 'string',
            headerFilter:"input"
            },
            {
            title: 'Site',
            field: 'site_id.label',
            sorter: 'string',
            headerFilter:"input"
            },
            {
            title: 'Sublocation',
            field: 'target_sublocation_id.label',
            sorter: 'string',
            headerFilter:"input"
            },
          ],
        },
        currentDocumentTypeCode: null,
        salesInvoiceModal: false,
        salesInvoiceData: [],
        suppliersBillData: [],
        transferAllocationData: [],
        countSetData: [],
        exportSelection: 0,
        accessRights: [],
        isRestrictedWithoutOriginDoc: false,
        documentNumber: 0,
        convertedJson: null,
        documentType: {document_type_id: 0},
        windowWidth: 0,
        errors: [],
        filterStatus: "",
        profileAction: "",
        checkedFields: [],
        checkedItems: [],
        availableFields: [],
        errorMessage: null,
        successMessage: null,
        componentKey: 0,
        modalKey: 0,
        drawerVisible: false,
        configVisible: false,
        configHistoryVisible: false,
        visible: false,
        deliveryDocumentDrawerVisible: false,
        reRoutedSODrawerVisible: false,
        customerReturnDrawerVisible: false,
        salesInvoiceDrawerVisible: false,
        suppliersBillDrawerVisible: false,
        transferAllocationDrawerVisible: false,
        countSetDrawerVisible: false,
        apiURL: "",
        isOrderSourceMode: false,
        fields: [],
        sortOrder: [
          {
            field: "id",
            direction: "desc"
          }
        ],
        httpOptions:{
            headers: {
                Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), 'Request-Source':"BXI-Web"
            }
        },
        css: {
            table: {
              tableClass: 'table table-sm table-striped table-bordered table-hovered',
              loadingClass: 'loading'
            },
            pagination: {
              infoClass: 'pull-right',
              wrapperClass: 'vuetable-pagination pull-right',
              activeClass: 'btn-primary btn-sm',
              disabledClass: 'disabled',
              pageClass: 'btn btn-border',
              linkClass: 'btn btn-border',
              icons: {
                first: '',
                prev: '',
                next: '',
                last: '',
              },
            }
        },
        radioStyle: {
          display: 'block',
          height: '30px',
          lineHeight: '30px',
        },
        documentEcomDrawerVisible:false,
        ecomAction:null,
        documentDetails:[],
        documentReferences:[],
        isRestrictedDisplayAllReferences:false,
        isRestrictedDisplayTotalQuantity:false,
        isRestrictedDisplayRemarks:false,
        isRestrictedDisplayShipOnTimeSLA:false,
        selectedPCount:[],
        pcountErrorMessage:null,
        loading: false,
        TAErrorMessage:null,
        allowCreationOfDDWithoutSO:false,
      }
    },
    watch: {
      selectedDocumentName: async function() {
        this.reload()
      },
      currentApiURL: function() {
        this.$refs.vuetable.resetData()
        this.apiURL = this.currentApiURL
      },
      parameters: function() {
        this.apiURL = this.currentApiURL
        this.apiURL = this.apiURL + this.parameters
        this.$refs.vuetable.selectedTo = []
        this.checkedItems = []
      }
    },
    methods: {
        moment,
        async reload(){
        this.loading = true
        var currentDocumentTypeId = secureStorage.getItem('documentTypeId')
        var document_config = await HTTPRequest.getRequest(this.endPoint+'/document_types/get_document_type_settings?id='+ currentDocumentTypeId, null)
        console.log(document_config)
        if(document_config.document_type_settings.references!=undefined){
          this.documentReferences = document_config.document_type_settings.references
        }
        if (document_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayAllReferences!=undefined){
          this.isRestrictedDisplayAllReferences = document_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayAllReferences
        }
        if (document_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayTotalQuantity!=undefined){
          this.isRestrictedDisplayTotalQuantity = document_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayTotalQuantity
        }
        if (document_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayRemarks!=undefined){
          this.isRestrictedDisplayRemarks = document_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayRemarks
        }
        if (document_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayShipOnTimeSLA!=undefined){
          this.isRestrictedDisplayShipOnTimeSLA = document_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayShipOnTimeSLA
        }
        if (document_config.document_type_settings.additionalEditorBehaviorCheckboxes.allowCreationOfDDWithoutSO!=undefined){
          this.allowCreationOfDDWithoutSO = document_config.document_type_settings.additionalEditorBehaviorCheckboxes.allowCreationOfDDWithoutSO
        }
        //Document Access Rights
        //var currentDocumentTypeName = secureStorage.getItem('documentTypeName')
        var currentDocumentTypeCode = secureStorage.getItem('documentTypeCode')
        this.currentDocumentTypeCode = currentDocumentTypeCode

        var system_module = await HTTPRequest.getRequest(this.endPoint+'/system_modules?status=A&code='+ currentDocumentTypeCode, null)
        var accessRightsRequest = await HTTPRequest.getRequest(this.endPoint + 'users/' + secureStorage.getItem("userId") + "/access_rights?system_module_id=" + system_module[0].id, null)


        if (accessRightsRequest.access_rights[system_module[0].id]) {
          this.accessRights  = accessRightsRequest.access_rights[system_module[0].id];
        } else {
          this.accessRights = [];
        }

        if (currentDocumentTypeCode=="OROTRQ" && document_config && document_config.document_type_settings.additionalEditorBehaviorCheckboxes.restrictWithoutOriginDoc) {
          this.isRestrictedWithoutOriginDoc = document_config.document_type_settings.additionalEditorBehaviorCheckboxes.restrictWithoutOriginDoc
        } else {
          this.isRestrictedWithoutOriginDoc = false
        }

        //Set Order Source
        var isSourceMode = null
        var user_settings = await HTTPRequest.getRequest(this.endPoint + '/user_settings?user_specific=Y&module_name=ORISOX');
        if (user_settings.data[0]) isSourceMode = user_settings.data[0].settings_json.isSourceMode
        var orisox_doc_config = await HTTPRequest.getRequest(this.endPoint+'/document_types/get_document_type_settings?type_code=SOX&trans_code=ORI', null)
        if (orisox_doc_config && orisox_doc_config.document_type_settings.orderSource){
            if (isSourceMode == null) isSourceMode = orisox_doc_config.document_type_settings.orderSource.enableOrderSourceMode || false
            this.isOrderSourceMode = isSourceMode
        }

        switch(currentDocumentTypeCode) {
          case 'ORITRQ':
            this.fields = ORIOROTRQ
            break;
          case 'OROTRQ':
            this.fields = ORIOROTRQ
            break;
          case 'RECTRX':
            this.fields = await this.addExtraColumn(RECTRX,'RECTRX')
            break;
          case 'RELTRX':
            this.fields = await this.addExtraColumn(RELTRX,'RELTRX')
            break;

          case 'ORICSQ':
            this.fields = ORIOROTRQ
            break;
          case 'OROCSQ':
            this.fields = ORIOROTRQ
            break;
          case 'RECCSX':
            this.fields = RECTRX
            break;
          case 'RELCSX':
            this.fields = RELTRX
            break;
          case 'OTHTRA':
            this.fields = await this.addExtraColumn(OTHTRA,'OTHTRA')
            var transfer_allocation_documents = []
            transfer_allocation_documents = await HTTPRequest.getRequest(this.endPoint+'documents/documents_for_transfer_allocation', null)
            if (transfer_allocation_documents.length > 0){
              this.transferAllocationData = transfer_allocation_documents
            }
            break;
          case 'OTHPCK':
            this.fields = OTHPCK
            break;


          case 'OTHPUR':
            this.fields = OTHPUR
            break;
          case 'ORIPOX':
            this.fields = await this.addExtraColumn(ORIPOX,'ORIPOX')
            break;
          case 'ORIASN':
            this.fields = ORIASN
            break;
          case 'RECDEL':
            this.fields = await this.addExtraColumn(RECDEL,'RECDEL')
            break;
          case 'RELRSR':
            this.fields = RELRSR
            break;
          case 'RECADJ':
            this.fields = await this.addExtraColumn(RECRELADJ,'RECADJ')
            break;
          case 'RELADJ':
            this.fields = await this.addExtraColumn(RECRELADJ,'RELADJ')
            break;
          case 'OTHUPC':
          case 'OTHPCN':
            this.fields = OTHPCN
            break;
          case 'OTHCNS':
            var pcount = []
            this.fields = OTHCNS
            pcount = await HTTPRequest.getRequest(this.endPoint+'documents/pcount_for_count_set_document', null)
            if (pcount.length > 0){
              this.countSetData = pcount
            }
            break;
          case 'OTHASM':
            this.fields = OTHASMDSM
            break;
          case 'OTHDSM':
            this.fields = OTHASMDSM
            break;

          case 'RELSLO':
            this.fields = RELSLO //TEMP
            break;
          case 'RECSLI':
            this.fields = RECSLI //TEMP
            break;
          case 'RECCSR':
            this.fields = RECCSR
            var source_documents = []
            source_documents = await HTTPRequest.getRequest(this.endPoint+'documents/customer_return_valid_sources', null)
            if (source_documents.length > 0){
              this.customerReturnData = source_documents
            }
            break;
          case 'OTHPWS':
            this.fields = OTHPWS
            break;

          case 'OTHSBI':
            var receiving_report_documents = []
            receiving_report_documents = await HTTPRequest.getRequest(this.endPoint+'documents/receiving_reports_for_suppliers_bill', null)
            if (receiving_report_documents.length > 0){
              this.suppliersBillData = receiving_report_documents
            }
            this.fields = OTHSBI
            break;

          case 'ORISOX':
            if (this.isOrderSourceMode == true) {
              this.fields = await this.addExtraColumn(ORISOXSRC,'ORISOXSRC')
              this.apiURL += '&isOrderSource=true'
            }else if (this.isOrderSourceMode == false) {
              this.fields = await this.addExtraColumn(ORISOX,'ORISOX')
              this.apiURL += '&isOrderSource=false'
            }else {
              this.fields = await this.addExtraColumn(ORISOX,'ORISOX')
            }
            break;

          case 'RELDDE':
            var sales_orders = []
            if (this.isOrderSourceMode == true) {
              // this.fields = RELDDESRC
              this.fields =  await this.addExtraColumn(RELDDESRC,'RELDDESRC')
              this.apiURL += '&isOrderSource=true'
              this.deliveryDocumentOptions.ajaxURL = this.endPoint+'documents/sales_orders_for_delivery_document?isOrderSource=true'
            }else if (this.isOrderSourceMode == false){
              this.fields =  await this.addExtraColumn(RELDDE,'RELDDE')
              this.apiURL += '&isOrderSource=false'
              this.deliveryDocumentOptions.ajaxURL = this.endPoint+'documents/sales_orders_for_delivery_document?isOrderSource=false'
            } else {
              this.fields =  await this.addExtraColumn(RELDDE,'RELDDE')
              this.deliveryDocumentOptions.ajaxURL = this.endPoint+'documents/sales_orders_for_delivery_document?isOrderSource=true'
            }
            if (sales_orders.length > 0){
              this.deliveryDocumentData = sales_orders
            }
            break;

          case 'OTHSIN':
            var delivery_documents = []
            if (this.isOrderSourceMode == true) {
              this.fields =  await this.addExtraColumn(OTHSINSRC,'OTHSINSRC')
              this.apiURL += '&isOrderSource=true'
              delivery_documents = await HTTPRequest.getRequest(this.endPoint+'documents/delivery_documents_for_sales_invoice?isOrderSource=true', null)

            }else if (this.isOrderSourceMode == false){
              this.fields =  await this.addExtraColumn(OTHSIN,'OTHSIN')
              this.apiURL += '&isOrderSource=false'
              delivery_documents = await HTTPRequest.getRequest(this.endPoint+'documents/delivery_documents_for_sales_invoice?isOrderSource=false', null)

            } else {
              this.fields =  await this.addExtraColumn(OTHSIN,'OTHSIN')
              delivery_documents = await HTTPRequest.getRequest(this.endPoint+'documents/delivery_documents_for_sales_invoice', null)

            }
            if (delivery_documents.length > 0){
              this.salesInvoiceData = delivery_documents
            }
            break;

          case 'ORORSO':
            var sales_orders = []
            if (this.isOrderSourceMode == true) {
              // this.fields = RELDDESRC
              this.fields =  await this.addExtraColumn(ORORSOSRC,'ORORSOSRC')
              this.apiURL += '&isOrderSource=true'
              this.ReRoutedSOOptions.ajaxURL = this.endPoint+'documents/sales_orders_for_re_routed_sales_order?isOrderSource=true'
            }else if (this.isOrderSourceMode == false){
              this.fields =  await this.addExtraColumn(ORORSO,'ORORSO')
              this.apiURL += '&isOrderSource=false'
              this.ReRoutedSOOptions.ajaxURL = this.endPoint+'documents/sales_orders_for_re_routed_sales_order?isOrderSource=false'
            } else {
              this.fields =  await this.addExtraColumn(ORORSO,'ORORSO')
              this.ReRoutedSOOptions.ajaxURL = this.endPoint+'documents/sales_orders_for_re_routed_sales_order?isOrderSource=true'
            }
            if (sales_orders.length > 0){
              this.reRoutedSOData = sales_orders
            }
            break;
          default:
              //TEMP
          }
          //Apply Table Field Changes
          this.$nextTick(()=>{
            if (this.$refs.vuetable != undefined) {
              this.$refs.vuetable.normalizeFields();
            }
          })
        },
        async salesOrderRowClick(e, row) {
            this.$router.push({ name: 'document_form', params: { id: -1, sales_order_id: row._row.data.id } })
        },
        async deliveryDocumentRowClick(e, row) {
            this.$router.push({ name: 'document_form', params: { id: -1, delivery_document_id: row._row.data.id } })
        },
        async receivingReportRowClick(e, row) {
            this.$router.push({ name: 'document_form', params: { id: -1, receiving_report_id: row._row.data.id } })
        },
        async transferAllocationRowClick(e, row) {
            var check_document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/check_origin_document_lines_for_TA?document_id='+row._row.data.id, null)
            if (check_document_lines["error"] == undefined){
              this.$router.push({ name: 'document_form', params: { id: -1, transfer_allocation_id: row._row.data.id } })
            }else{
              this.TAErrorMessage = check_document_lines["error"]
            }
        },
        async transferAllocationNoOrigin() {
            this.$router.push({ name: 'document_form', params: { id: -1 } })
        },
        async DeliveryDocumentNoOrigin() {
            this.$router.push({ name: 'document_form', params: { id: -1 } })
        },
        ...mapActions(['updateProfileId']),
        closeDrawer(){
          this.onClose();
        },
        refreshPage(){
          this.onClose()
          this.$refs.vuetable.refresh()
          this.successMessage = "Successful Operation"
          this.errorMessage = null
        },
        showModal(id) {
          this.modalKey++;
          if (this.currentDocumentTypeCode == "RELDDE") {
            this.deliveryDocumentModal = true;
          }else if (this.currentDocumentTypeCode == 'OTHSIN') {
            this.salesInvoiceModal = true;
          }else if (this.currentDocumentTypeCode == 'RECCSR'){
            this.customerReturnModal = true;
          }else if (this.currentDocumentTypeCode == 'ORORSO') {
            this.reRoutedSOModal = true;
          }
          this.updateProfileId(id);
        },
        async showDrawer(id) {
          this.documentNumber = id
          this.componentKey++
          this.updateProfileId(id)
          this.visible = true
        },
        onLoaded(){
          this.loading = false;
        },
        async showActionDrawer(action) {
          if(action == "customize_list"){
            var response = await HTTPRequest.getRequest(this.endPoint + "documents/get_viewable_fields" , null)
            let unsortedFields = response["fields"];
            let sortedFields = this.checkedFields.slice();

            unsortedFields.forEach(fieldName => {
              if (!this.checkedFields.includes(fieldName))
                sortedFields.push(fieldName)
            });

            this.availableFields = sortedFields;
          }
          this.componentKey++
          this.profileAction = action
          if (action == "configure"){
            this.configVisible = true
          } else if(action == "configurationhist") {
            this.configHistoryVisible = true
          } else {
            this.drawerVisible = true
          }

        },
        async showDocumentDrawer(profile) {
          this.componentKey++
          if (profile=='Delivery Document'){
            this.deliveryDocumentDrawerVisible = true
          } else if (profile == 'Sales Invoice') {
            this.salesInvoiceDrawerVisible = true
          } else if (profile == 'Customer Return') {
            this.customerReturnDrawerVisible = true
          } else if (profile == 'Suppliers Bill') {
            this.suppliersBillDrawerVisible = true
          } else if (profile == 'Transfer Allocation') {
            this.transferAllocationDrawerVisible = true
          } else if (profile == 'Re-Routed Sales Order') {
            this.reRoutedSODrawerVisible = true
          } else if (profile == 'Count Set') {
            this.countSetDrawerVisible = true
          }
        },

        onClose() {
          this.errors = [];
          this.configVisible = false
          this.configHistoryVisible = false
          this.drawerVisible = false
          this.deliveryDocumentDrawerVisible = false
          this.reRoutedSODrawerVisible = false
          this.salesInvoiceDrawerVisible = false
          this.customerReturnDrawerVisible = false
          this.suppliersBillDrawerVisible = false
          this.visible = false
          this.transferAllocationDrawerVisible = false
          this.documentEcomDrawerVisible = false
          this.countSetDrawerVisible = false
          this.componentKey++
        },
        log(){
          this.checkedItems = this.$refs.vuetable.selectedTo
        },
        onCheckField(fieldName){
          if(this.fields.includes(fieldName)){
            var indexValue = this.fields.indexOf(fieldName)
            if(indexValue > -1) this.fields.splice(indexValue,1)
            var indexValue2 = this.checkedFields.indexOf(fieldName)
            if(indexValue2 > -1) this.checkedFields.splice(indexValue2,1)
          } else {
            this.fields.pop()
            this.fields.push(fieldName)
            this.fields.push("__slot:actions")
            this.checkedFields.push(fieldName)
          }
          // console.log(this.fields)
          this.$refs.vuetable.normalizeFields()
        },
        onCheckAllField(){
        },
        async massupdate(field_name,value){
          var field_update = {}
          field_update[field_name] = value
          var payload = {ids: this.checkedItems, field_update: field_update }
          var response = await HTTPRequest.postRequest(this.endPoint + this.currentProfile + "/mass_update" , null, payload)
          if(response["message"] == "Ok"){
              this.successMessage = "Update successful!"
              this.$refs.vuetable.refresh()
              this.checkedItems = []
              this.$refs.vuetable.selectedTo = []
          } else {
              this.successMessage = "Update failed!"
              // alert("Error processing")
          }
        },
        async onPaginationData(paginationData) {
        //   await axios({
        //     method: 'PUT',
        //     url: this.endPoint.split("/api")[0] + "/api/v2/backend_sessions/" + secureStorage.getItem("sessionId") + "/update_timestamp",
        //     headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web" },
        // })
          this.$refs.pagination.setPaginationData(paginationData);
        },
        async onLoadError(error){
          // request for new token or reauthenticate
          if(error.response.status == 401){
            var  auth_response = await HTTPRequest.authenticate(component_x.endPoint)
            if(auth_response["status"] == "Ok"){
              this.$router.go();
            }else{
              alert("Cannot get access token. Please login again.")
              this.$router.push("/")
            }
          }  else {
            if(error.response.data.error == "Session expired"){
                alert("Session is already expired. Please login again.")
                document.getElementById("logoutButton").click()
            }
          }
        },
        onChangePage(page) {
          this.$refs.vuetable.changePage(page);
        },
        deleteRow(id){
            var endPoint = this.endPoint //For second api request(post action history)
            axios({
            method: 'delete',
            url: this.endPoint + 'documents/' + id,
            headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web" },
            })
            .then(function () {
              axios({
                method: 'post',
                url: endPoint + 'document_action_histories/',
                data: {
                    action: "VOIDED",
                    action_at: moment(new Date()),
                    action_by: secureStorage.getItem("userName"),
                    document_id: id,
                    status: "D"
                },
                headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web" },
                })
                .then(function () {
                    component_x.successMessage = "Successfully deleted record"
                    component_x.$refs.vuetable.refresh()
                })
                .catch(function (e) {
                  console.log(e)
                  alert("Invalid Credentials1")
              });
            })
            .catch(function (e) {
              var err_msg = JSON.parse(e.request.response).error
              component_x.errorMessage = err_msg[0]
            });
        },
        download(){ // Must update other Profile Tables download function to be aligned
          var payload = {}
          var additional_parameters = ""
          var baseUrl = this.currentApiURL + "/download?file_type=csv"
          if(this.exportSelection == "0"){
            // All
            payload["type"] = "all"
          }else if(this.exportSelection == "1"){
            // Current Page
            var ids = this.$refs.vuetable.tableData.map(({id}) => id)
            payload["type"] = "current_page";
            if (ids == 0) {
              this.errors.push('No Record(s)');
              return;
            }else {
              payload["ids"] = ids
            }

          }else if(this.exportSelection == "2"){
            // Selected
            payload["type"] = "selected"
            if (this.checkedItems == 0) {
              this.errors.push('No Selected Record(s)');
              return;
            }else {
              payload["ids"] = this.checkedItems
            }
          }else{
            // Filtered
            payload["type"] = "filtered"
            additional_parameters = this.parameters
          }

          var exportFields = this.fields
          var cbIndex = this.fields.indexOf("__checkbox");
          if(cbIndex > -1) exportFields.splice(cbIndex,1)
          var actionIndex = this.fields.indexOf("__slot:actions");
          if(actionIndex > -1) exportFields.splice(actionIndex,1)

          payload["fields"] = exportFields
          additional_parameters = additional_parameters.replace('?','&');

          axios({
            url: baseUrl + additional_parameters ,
            method: 'POST',
            responseType: 'blob', // important
            headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File"},
            data: payload,
          }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'file.csv');
            document.body.appendChild(link);
            link.click();
            this.onClose();
            this.filterStatus = null
            this.successMessage = "Download successful"
          });
        },
        displayMessage( message ){
          if(message["error"] != undefined){
            this.onClose()
            this.errorMessage = message["error"]
            this.successMessage = null
          }
        },
        removeMessage( type ){
          if(type == 'error'){
            this.errorMessage = null
            this.pcountErrorMessage = null
            this.TAErrorMessage = null
          }else
            this.successMessage = null
        },
        getWindowWidth(event) { //for fullscreen drawer
          this.windowWidth = window.innerWidth
        },
        deleteEcomOrder(data){
          this.documentEcomDrawerVisible = true
          this.documentDetails = data
          this.ecomAction = 'Void'
        },
        addExtraColumn: async function(data,code){
          if (this.isRestrictedDisplayTotalQuantity){
            data.findIndex(x => x.name == 'total_quantity')<0 ? data.push({ name: 'total_quantity', title: 'qty', sortField: 'total_quantity'}) : ''
          }
          if (code =="ORISOXSRC" || code =="ORISOX" || code == "RELDDESRC" || code == "RELDDE" || code == "OTHSINSRC" || code == "OTHSIN") {
            var index = data.findIndex(x => x.name == 'reference')
            index<0 ? data.push({ name: 'reference', title: this.documentReferences[0].name}) : data[index].title = this.documentReferences[0].name
          }
          if (this.isRestrictedDisplayAllReferences){
            if (code=="RECDEL"){
              data.findIndex(x => x.name == 'reference_1')<0 ? data.push({ name: 'reference_1', title: this.documentReferences[0].name}) : ''
            }
            data.findIndex(x => x.name == 'reference_2')<0 ? data.push({ name: 'reference_2', title: this.documentReferences[1].name}) : ''
            data.findIndex(x => x.name == 'reference_3')<0 ? data.push({ name: 'reference_3', title: this.documentReferences[2].name}) : ''
            data.findIndex(x => x.name == 'reference_4')<0 ? data.push({ name: 'reference_4', title: this.documentReferences[3].name}) : ''
            data.findIndex(x => x.name == 'reference_5')<0 ? data.push({ name: 'reference_5', title: this.documentReferences[4].name}) : ''
            data.findIndex(x => x.name == 'reference_6')<0 ? data.push({ name: 'reference_6', title: this.documentReferences[5].name}) : ''
            data.findIndex(x => x.name == 'reference_7')<0 ? data.push({ name: 'reference_7', title: this.documentReferences[6].name}) : ''
            data.findIndex(x => x.name == 'reference_8')<0 ? data.push({ name: 'reference_8', title: this.documentReferences[7].name}) : ''
            data.findIndex(x => x.name == 'reference_9')<0 ? data.push({ name: 'reference_9', title: this.documentReferences[8].name}) : ''
            data.findIndex(x => x.name == 'reference_10')<0 ? data.push({ name: 'reference_10', title: this.documentReferences[9].name}) : ''
          }
          if (this.isRestrictedDisplayRemarks){
            data.findIndex(x => x.name == 'remark')<0 ? data.push({ name: 'remark', title: 'Warehouse Remarks'}) : ''
          }
          if (this.isRestrictedDisplayShipOnTimeSLA){
            data.findIndex(x => x.name == '__slot:target_date')<0 ? data.push({name:"__slot:target_date", title: "Ship-on-Time SLA"}) : ''
          }
          return data
        },
        addCountSetCheckBox (cell, formatterParams){
          let id = cell.getRow().getData().id
          var button = ""
          var index = this.selectedPCount.findIndex(x => x.id == id)
          var status = index >= 0 ? 'checked' : ''
          button += '<input type="checkbox" id="' + id + '" '+status+' />'
          return button
        },
        selectPCountAction: function(e, cell){
          if(e.target.id == cell.getRow().getData().id && e.srcElement.checked!=undefined){
            if (e.srcElement.checked){
              this.selectedPCount.push(cell.getRow().getData())
            }else{
              var checkPCount = this.selectedPCount.findIndex(x => x.id == e.target.id)
              checkPCount>=0 ? this.selectedPCount.splice(checkPCount,1) : ''
            }
          }
        },
        async countSetClickNext() {
          if (this.selectedPCount.length > 0){
            this.$router.push({ name: 'document_form', params: { id: -1, pcount_data: this.selectedPCount } })
          }else{
            this.pcountErrorMessage = "select atleast one physical count document"
          }
        },
        SLAfunction(value) {
          let sDate = moment(new Date(value));
          if (((sDate - this.dateNow) / 36e5) < 24){
            return '<span class="text-success font-weight-bold ">'+value+'</span>'
          }else if (((sDate - this.dateNow) / 36e5) > 24 && ((value - this.dateNow) / 36e5) > 0){
            return '<span class="text-warning font-weight-bold ">'+value+'</span>'
          }else if (((sDate - this.dateNow) / 36e5) < 0){
            return '<span class="text-danger font-weight-bold ">'+value+'</span>'
          }else {
            return '<span class="font-weight-bold ">'+value+'</span>'
          }
        },
        async GenerateBatchPickingList() {
          var post_request = await HTTPRequest.postRequest(this.endPoint + 'documents/generate_batch_picking_list', null, {document_id:this.checkedItems})
          if(post_request["message"] == "Ok"){
            this.successMessage = "Generate successful!"
            this.$refs.vuetable.refresh()
            this.checkedItems = []
            this.$refs.vuetable.selectedTo = []
          } else {
            this.errorMessage = post_request["error"]
          }
        },
    },
    mounted: async function() {
        component_x = this;
        this.apiURL = this.currentApiURL;

        secureStorage.setItem("documentTypeInternalCode", this.$attrs["documentType"])
        // this.documentTypex = this.$attrs["documentType"]

        var user_settings = await HTTPRequest.getRequest(this.endPoint + '/user_settings?user_specific=Y&module_name=ORISOX');
        if (user_settings.data[0]) this.isSourceMode = user_settings.data[0].settings_json.isSourceMode

        this.$nextTick(function() { //for fullscreen drawer
          window.addEventListener('resize', this.getWindowWidth);
          this.getWindowWidth()
        })
        await this.reload()
    },
    beforeDestroy() { //for fullscreen drawer
      window.removeEventListener('resize', this.getWindowWidth);
    },
  }
</script>

<style scoped>
</style>
